import { useState } from 'react'
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { Paper, TextField, Tooltip, Typography, Grid, Autocomplete, Button, CircularProgress } from '@mui/material';
import { Edit as EditIcon, } from '@mui/icons-material';
import { updateSDConfigApi } from '../apiService';
import { globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { PageLoader } from '../../../../shared_elements';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
function SecurityDepositConfig({ currencyData,dropDownLoader, sdcData, getResponseBack, securityDepositInfo }) {
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [modeType, setModeType] = useState('view')
    const [error, setError] = useState({});
    const [data, setData] = useState(sdcData ? sdcData : { base_currency: null, contractual_currency: null });

    const onFieldChange = (keyParam, value) => {
        setData({ ...data, [keyParam]: value });
    }

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const onUpdateSDC = () => {
        let validationInputs = {};
        validationInputs = {
            contractual_currency: data?.contractual_currency?.name ? "" : "Please enter Contractual Currency",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data?.id) {
                globalPutService(updateSDConfigApi(params), data)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            setModeType('view')
                            getResponseBack()
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Security Deposit Config`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Security Deposit Config`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        }
                    })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item Edited`, { page_title: `Edit Security Deposit Config`, error_msg: validationInputs, })
        }
    }
const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Security Deposit Config`, page_type: page_type, })
    }
    return (
        <section className='security-deposite-config' style={{ position: securityDepositInfo ? 'sticky' : '', zIndex: securityDepositInfo ? 999 : '', top: 0, background: 'white', margin: '0px 0px 10px 0px', }}>
            <Grid className="security-deposite-config-container" container spacing={2} sx={{ padding: "5px" }}>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Typography sx={{ fontFamily: "Roboto-Regular" }}>Security Deposit Config</Typography>
                </Grid>
                <Grid className="security-deposite-config-right-item" size={{ md: 6, xs: 12 }} sx={{ textAlign: 'right' }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "security_deposit", operationType: ['U'] }}>
                        {modeType === 'edit' ? null : <Tooltip title="Edit"> <EditIcon onClick={() => {setModeType('edit'); handleItemClicked('EditIcon')}} sx={{ cursor: 'pointer' }} size="small" color="primary" /> </Tooltip>}
                    </PermissionWrapper>
                    {modeType === 'edit' ? <Button onClick={() => { setModeType('view'); setError({}); setData(sdcData); handleItemClicked('Cancel Button') }} sx={{ cursor: 'pointer', marginInline: '5px' }} size="small" color="primary" variant='outlined'>Cancel</Button> : null}
                    {modeType === 'edit' ? <Button onClick={() => { handleItemClicked('Save Button'); onUpdateSDC() }} sx={{ cursor: 'pointer' }} size="small" color="primary" variant='contained'>Save</Button> : null}
                </Grid>
            </Grid>
            <Paper className='security-deposite-config-dropdown' square elevation={1} sx={{ background: '#EAEAEA', padding: "15px 0px 15px 15px" }}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            disableClearable
                            options={currencyData || []}
                            getOptionLabel={(option) => option?.name || ""}
                            noOptionsText={dropDownLoader ? "loading" :"No Option Available" }
                            disabled={modeType === 'view'}
                            value={data?.contractual_currency ?? null}
                            onFocus={() => onRestErrorKey("contractual_currency")}
                            onChange={(e, value) => onFieldChange("contractual_currency", value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    label="Contractual Currency"
                                    margin='normal'
                                    size='small'
                                    error={!!error.contractual_currency}
                                    helperText={error.contractual_currency}
                                    slotProps={{ inputLabel: { shrink: true } , input:{ ...params?.InputProps,endAdornment: (<>{dropDownLoader ? ( <CircularProgress color="inherit" size={20} />) : null} {params?.InputProps?.endAdornment} </> ) }} }
                                    disabled={modeType === 'view'}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{ md: 3, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={currencyData || []}
                            getOptionLabel={(option) => option?.name || ""}
                            disabled={modeType === 'view'}
                            value={data?.base_currency || null}
                            noOptionsText={dropDownLoader ? "loading" :"No Option Available" }
                            onFocus={() => onRestErrorKey("base_currency")}
                            onChange={(e, value) => onFieldChange("base_currency", value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Base Currency"
                                    margin='normal'
                                    size='small'
                                    slotProps={{ inputLabel: { shrink: true } , input:{ ...params?.InputProps,endAdornment: (<>{dropDownLoader ? ( <CircularProgress color="inherit" size={20} />) : null} {params?.InputProps?.endAdornment} </> ) }} }
                                    disabled={modeType === 'view'}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}

export default SecurityDepositConfig